module.exports = __webpack_public_path__ + "static/media/skopei-360-inline.b105cb35.svg";